import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hall-fama',
  templateUrl: './hall-fama.component.html',
  styleUrls: ['./hall-fama.component.css']
})
export class HallFamaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
